import { sharedEnvironment } from "../config/environmentService";

const DEFAULT_MEDIA_STREAMING_DISTRIBUTION_URL = sharedEnvironment.defaultMediaStreamingDistributionUrl;
const MEDIA_STREAMING_DISTRIBUTION_URL = sharedEnvironment.mediaStreamingDistributionUrl;

export const getMediaStreamingUrl = (url?: string | null | undefined): string => {
  if (!url) return "";
  return url.replace(DEFAULT_MEDIA_STREAMING_DISTRIBUTION_URL, MEDIA_STREAMING_DISTRIBUTION_URL);
};
